import React from 'react';
import PropTypes from 'prop-types';

import NotFound from '../NotFound';

/* Essentials */
import introduction from './static/introduction.html';
import serverAuthentication from './static/serverAuthentication.html';
import clientAuthentication from './static/clientAuthentication.html';
import commonObjects from './static/commonObjects.html';
import makeRequest from './static/makeRequest.html';
import rateLimiting from './static/rateLimiting.html';

/* Misc */
import postRouting from './static/postRouting.html';
import jsonTypes from './static/jsonTypes.html';
import imageFormats from './static/imageFormats.html';
import cors from './static/cors.html';

//* Advanced Topics * //
import continuableList from './static/continuableListResponses.html';
import batchRequests from './static/batchRequests.html';

class HtmlPage extends React.PureComponent {

	componentDidMount() {
		if (window.Prism) { window.Prism.highlightAll() }
	}

	componentDidUpdate() {
		if (window.Prism) { window.Prism.highlightAll() }
	}

	render() {
		const { page } = this.props;

		let html = null;
		let jsx = null;
		switch (page) {
			case 'introduction': html = introduction; break;
			case 'server-authentication': html = serverAuthentication; break;
			case 'client-authentication': html = clientAuthentication; break;
			case 'common-objects': html = commonObjects; break;
			case 'making-a-request': html = makeRequest; break;
			case 'rate-limiting': html = rateLimiting; break;
			case 'post-routing': html = postRouting; break;
			case 'json-data-types': html = jsonTypes; break;
			case 'image-formats': html = imageFormats; break;
			case 'batch-requests': html = batchRequests; break;
			case 'continuable-list': html = continuableList; break;
			case 'cors': html = cors; break;
			default: return (<NotFound partial={true} />);
		}

		return (
			<div>
				<div className="part" dangerouslySetInnerHTML={{ __html: html }}></div>
				{jsx}
			</div>
		);
	}
}

HtmlPage.propTypes = {
	page: PropTypes.string.isRequired
};

export default HtmlPage;



// WEBPACK FOOTER //
// ./src/components/getting-started/HtmlPage.js